module.exports = __webpack_public_path__ + "static/media/ny_title.95e2282f.png";